// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2aD-1","modalForm":"UpgradeEpcsModal_modalForm__2JjRF","modalFooter":"UpgradeEpcsModal_modalFooter__VKu-m"};